import { ref } from 'vue';
import { prepareImage } from '~/components/kiosk/kiosk-ten-dlc/registration/registrationImage';

export const useOptInScreenshot = () => {
    const screenshot = ref<File | null>(null);
    const screenshotError = ref('');

    // Prepared on selection so the admin sees the resulting size before submitting.
    const onScreenshotChange = async (event: Event) => {
        const input = event.target as HTMLInputElement;
        const file = input.files?.[0] ?? null;
        // Cleared so picking the same file again fires change.
        input.value = '';
        screenshot.value = null;
        screenshotError.value = '';

        if (!file) {
            return;
        }

        try {
            screenshot.value = await prepareImage(file);
        } catch (e) {
            screenshotError.value = e instanceof Error ? e.message : 'The screenshot could not be prepared.';
        }
    };

    return { screenshot, screenshotError, onScreenshotChange };
};
